import { MenuItem } from 'app/core/models/menu/menu.model';

export function hasActiveDescendant(item: MenuItem, url: string): boolean {
  const path = url.split('?')[0].split('#')[0];
  if (item.route && (path === item.route || path.startsWith(`${item.route}/`))) {
    return true;
  }
  return !!item.subMenu?.some((child) => hasActiveDescendant(child, url));
}
